export default __webpack_public_path__ + "static/work-a625358d9a7f3b2986b5872651186a5c.png";